export default {
  regPlayerMinimumSeasonSessionCount: 5,
  regPlayerMinimumGeneralSessionCount: 10,
  green: "#10B981",
  red: "#EF4444",
  indigo: "#4F46E5",
  forceEditMode: false,
};
